// @ts-nocheck
import { ref, set, get, child, update } from "firebase/database";
import { getDatabase } from "firebase/database";

// Fixo no Game Design
const estrelas = {
    1: 2999,
    2: 3700,
    3: 4700  
}

const rootNode = 'cruzadinhas/covid/'

export default class usuario {

  private database
  private databaseUser
  public estrelas = estrelas
  modos = 5
  public progresso = {
    
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0
    
  }
  public pontos = {
    
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0
  
}
  public tempo = {
      1: { seconds: 0, minutes: 0 },
      2: { seconds: 0, minutes: 0 },
      3: { seconds: 0, minutes: 0 },
      4: { seconds: 0, minutes: 0 },
      5: { seconds: 0, minutes: 0 },
      6: { seconds: 0, minutes: 0 },
      7: { seconds: 0, minutes: 0 },
      8: { seconds: 0, minutes: 0 },
      9: { seconds: 0, minutes: 0 },
      10: { seconds: 0, minutes: 0 }
  }

  public rank = {
    pontuacao: 0,
    ultimoAcesso: Date.now(),
    tempo: { seconds: 0, minutes: 0 }
  }

  constructor(
    public user: any,
    public nick: string,
    public firebase: any
  ) {
    // Get a reference to the database service
    this.database = getDatabase(firebase);
    console.log(this.database);
    
    this.databaseUser = ref(this.database, rootNode + 'usuarios/')
    this.databasePlacar = ref(this.database,  rootNode +'placar/')

    if (user !== null) {
      this.checkUser(user)
    } else {
      console.log("Erro: Sem usuário");
    }
  }

  checkUser(user: any) {
    get(child(this.databaseUser, `/${user.uid}`)).then((snapshot) => {
      if (snapshot.exists()) {
        this.loadUsuario(snapshot.val())
      } else {
        this.create(user)
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  create(user: any) {
    this.setNickname(user.displayName);
    set(ref(this.database, rootNode +  "usuarios/" + this.user.uid), this.saveUsusario(this));
    set(ref(this.database, rootNode +  "placar/" + this.user.uid), this.saveColocacao(this));

  }

  setNickname(nick: string) {
    this.nick = nick
  }

  public setProgresso( fase: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10  , pontos: number, tempo: any) {
    // Fixo pelo Game Design
    if (estrelas[3] <= pontos)
      this.progresso[fase] = 3
    else if (estrelas[2] <= pontos)
      this.progresso[fase] = 2
    else if (estrelas[1] <= pontos)
      this.progresso[fase] = 1

    // Carregando Tempo e pontos
    this.tempo[fase] = tempo
    this.pontos[fase] = pontos
    this.rank.pontuacao = 0

    // Somatoria dos pontos para update rank 
    for (let i in this.pontos) {
        this.rank.pontuacao += this.pontos[i]
    }

    // Somatoria do tempo total em jogo trantando a base de tempo  
    this.rank.tempo = { seconds: 0, minutes: 0 }
    let aux = { seconds: 0, minutes: 0 }
    for (let i in this.tempo) {
        aux = this.tempo[i]
        this.rank.tempo.minutes += aux.minutes
        this.rank.tempo.seconds += aux.seconds
    }

    this.rank.tempo.minutes += Math.floor(this.rank.tempo.seconds / 60, 1)
    this.rank.tempo.seconds = this.rank.tempo.seconds % 60
    this.updateUsuario()
  }



  updateUsuario() {
    update(ref(this.database, rootNode +  "usuarios/" + this.user.uid), this.saveUsusario(this));
    update(ref(this.database, rootNode +  "placar/" + this.user.uid), this.saveColocacao(this));
  }

  saveColocacao(usuario: usuario) {
    let colocacao = {
      'nick': usuario.nick,
      'pontuacao': usuario.rank.pontuacao,
      'tempo': usuario.rank.tempo,
      'ultimoAcesso': usuario.rank.ultimoAcesso
    }
    return colocacao
  }

  saveUsusario(usuario: usuario) {
    let user = {
      'nick': usuario.nick,
      'progresso': usuario.progresso,
      'pontos': usuario.pontos,
      'tempo': usuario.tempo,

      'rank': {
        'pontuacao': usuario.rank.pontuacao,
        'tempo': usuario.rank.tempo,
        'ultimoAcesso': usuario.rank.ultimoAcesso,
      }
    }
    return user
  }

  loadUsuario(usuario: usuario) {
    // Deserializando usuario
    this.nick = usuario.nick

    this.progresso = usuario.progresso
    this.pontos = usuario.pontos
    this.tempo = usuario.tempo

    this.rank.pontuacao = usuario.rank.pontuacao
    this.rank.tempo = usuario.rank.tempo
  }

}
